<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import ListboxField from '@js/components/fields/ListboxField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref } from 'vue';
import { object } from 'yup';

const appointmentFrequencies = [
    { value: 'monthly', label: 'Mensuel' },
    { value: 'bimonthly', label: 'Bimensuel' },
    { value: 'quarterly', label: 'Trimestriel' },
    { value: 'semiannual', label: 'Semestriel' },
    { value: 'yearly', label: 'Annuel' },
];

const props = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const form = reactive({
    appointmentFrequency: props.tenant.appointmentFrequency
        ? appointmentFrequencies.find(
              (frequency) =>
                  frequency.value === props.tenant.appointmentFrequency,
          )
        : null,
});

const validationSchema = object({
    appointmentFrequency: object().nullable(),
});

const isOpen = ref(false);

function setIsOpen(value) {
    isOpen.value = value;
}

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route(
                'front.projectManagement.apikom.postSaveAppointmentFrequency',
                {
                    tenant: props.tenant.id,
                },
            ),
            {
                appointmentFrequency: form.appointmentFrequency
                    ? form.appointmentFrequency.value
                    : null,
            },
        )
        .then(() => {
            setIsOpen(false);

            if (props.callback) {
                props.callback();
            }
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <DialogDrawer>
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            <div class="flex items-center">
                Mettre à jour la fréquence des RDV
            </div>
        </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <ListboxField
                            v-model="form.appointmentFrequency"
                            field-id="appointmentFrequency"
                            field-name="appointmentFrequency"
                            label="Récurrence RDV"
                            :options="appointmentFrequencies"
                            has-empty-option
                        >
                            <template #buttonContent>
                                {{ form.appointmentFrequency.label }}
                            </template>

                            <template #optionContent="{ option }">
                                {{ option.label }}
                            </template>
                        </ListboxField>
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    withoutBackButton
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
